import ICallbackFunctionRenderPage from "../../interfaces/callbackRenderPage";

export default abstract class ComponentBase{
    protected elementRendered:HTMLElement;

    constructor(
        protected container:HTMLElement,
        protected idElement:string,
        protected elementToRender:string
    ){
    }

    renderWithCB(cb:ICallbackFunctionRenderPage):HTMLElement{
        this.container.insertAdjacentHTML("beforeend",this.elementToRender);
        this.elementRendered = this.container.lastElementChild as HTMLElement;
        cb(this.container,this.elementRendered,this.idElement);
        return this.elementRendered;
    }

    render():HTMLElement{
        this.container.insertAdjacentHTML("beforeend",this.elementToRender);
        this.elementRendered = this.container.lastElementChild as HTMLElement;
        return this.elementRendered;
    }
}